import { GipEvidenceExportConditionsDto } from '@app/modules/audit/modules/aod/aod.types';
import { GipExportConditionsValues } from '../types';

export function gipExportConditionsValuesToApi(
  values: GipExportConditionsValues,
): GipEvidenceExportConditionsDto {
  return {
    minEfficiency: values.enableEfficiency ? values.minEfficiency : false,
  } as GipEvidenceExportConditionsDto;
}

export function gipExportConditionsValuesFromApi(
  values: GipEvidenceExportConditionsDto,
): GipExportConditionsValues {
  return {
    enableEfficiency: values.minEfficiency !== false,
    minEfficiency: values.minEfficiency === false ? 0 : values.minEfficiency!,
  };
}
